import type { ReactNode } from "react";
import { useReveal } from "@/hooks/useReveal";

type Props = {
  as?: keyof React.JSX.IntrinsicElements;
  delay?: 0 | 1 | 2 | 3 | 4;
  className?: string;
  children: ReactNode;
};

export function Reveal({ as = "div", delay = 0, className, children }: Props) {
  const { ref, className: revealClass } = useReveal<HTMLDivElement>();
  const Tag = as as "div";
  const delayCls = delay ? ` reveal-delay-${delay}` : "";
  return (
    <Tag
      ref={ref}
      className={`${revealClass}${delayCls} ${className ?? ""}`}
    >
      {children}
    </Tag>
  );
}
